import { render, staticRenderFns } from "./PWYSIWYG.vue?vue&type=template&id=6f48401e&"
import script from "./PWYSIWYG.vue?vue&type=script&lang=ts&"
export * from "./PWYSIWYG.vue?vue&type=script&lang=ts&"
import style0 from "./PWYSIWYG.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports